<template lang="html">
    <div class="page" v-if="player">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2 green">
            <header>
                <h2>Key Reminders</h2>
                <ul class="links">
                    <li>
                        <a @click.prevent="$router.back()" class="cancel"
                            ><x-icon class="icon"
                        /></a>
                    </li>
                </ul>
            </header>

            <div class="info player" style="margin-bottom: 10px">
                {{ player.first_name }} {{ player.last_name }}
            </div>

            <empty-placeholder class="mt30" v-if="reminders.length == 0">
                TIP: Create simple key reminders to help your Players before they step out on to the
                course. To get started tap the button below.
            </empty-placeholder>

            <button
                @click.prevent="editOpen = !editOpen"
                class="button dark mb30 left"
                type="button"
                name="button"
            >
                Add reminder
                <plus-icon class="icon" />
            </button>

            <add-edit-reminder
                v-if="editOpen"
                @formClosed="closeForm"
                @reminderAdded="addReminder"
            />

            <div id="keyReminders">
                <ul>
                    <reminder-item
                        @formOpen="editChildOpen = true"
                        @formClosed="editChildOpen = false"
                        type="pro"
                        v-for="reminder in reminders"
                        :key="reminder.id"
                        :reminder="reminder"
                        @reminderDeleted="deleteReminder"
                        @updateReminder="reminderUpdate"
                    />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import AddEditReminder from "@/views/Pro/Players/Player/partials/add-edit-reminder";
import ReminderItem from "@/components/Shared/Reminder-item";
import { PlusIcon, XIcon } from "vue-feather-icons";
export default {
    name: "reminders",
    components: { EmptyPlaceholder, FadeImage, AddEditReminder, ReminderItem, PlusIcon, XIcon },
    mounted() {
        if (!this.$store.state.activePlayer) {
            this.$store.dispatch("getPlayer", this.$route.params.id);
        }
        this.getReminders();
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    data() {
        return {
            editOpen: false,
            reminders: [],
            editChildOpen: false,
        };
    },
    methods: {
        closeForm() {
            this.editOpen = false;
            this.editChildOpen = false;
        },
        addReminder(reminder) {
            this.reminders.unshift(reminder);
        },
        reminderUpdate(reminder) {
            var index = this.reminders.findIndex(($reminder) => {
                return $reminder.id == reminder.id;
            });

            this.reminders.splice(index, 1, reminder);
        },
        deleteReminder(reminder) {
            var index = this.reminders.findIndex(($reminder) => {
                return $reminder.id == reminder.id;
            });

            this.reminders.splice(index, 1);
        },
        getReminders() {
            window.axios.get("/player/" + this.$route.params.id + "/reminders").then((response) => {
                this.reminders = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.player {
    background: white;
    font-size: 16px;
}
</style>
